encodedLetterString = (function() {

	function get (name) { return privateVars[name]; }

	var privateVars = {
		asciiBase : 65, 

		numberOfLetters : 26,

		numToLetter: function (number)	{
				if(number < 26) 
					return String.fromCharCode(number + get('asciiBase')); 
				return get('numToLetter')((Math.floor(number / get('numberOfLetters')) - 1)) + get('numToLetter')((number % get('numberOfLetters')));
			}
	};

	var publicVars = {
		indexToAlpha: function (index) {
			if(index < 0 || !_(index).isNumber()) 
				throw "Invalid Index for Conversion to Alpha: " + index;

			return '[' + get('numToLetter')(index) + ']';
		},
		
		alphaToIndex: function (chr) {
			var strippedString = chr.replace(/\[|\]/g, ''); //get rid of the brackets
			var value = 0;
			for(i=0; i < strippedString.length; i++) {
				var power = (strippedString.length - i) - 1;
				var index = (strippedString.charCodeAt(i) - get('asciiBase')) + 1;
				value += index * Math.pow(get('numberOfLetters'), power);
			}
			
			return value-1;
		}
	};

	return publicVars;

})();

